interface IconProps {
  className?: string;
}
const AttachFilesIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <g fill="currentColor" clipPath="url(#clip0_635_22750)">
        <path d="M7.185 5.526c-1.65 1.706-1.29 4.539.6 5.794a.16.16 0 0 0 .199-.02c.397-.388.734-.765 1.029-1.244a.15.15 0 0 0-.059-.209 1.9 1.9 0 0 1-.736-.758 1.85 1.85 0 0 1-.158-1.263c.119-.57.731-1.101 1.2-1.592l-.003-.001 1.753-1.79a1.8 1.8 0 0 1 2.555-.013 1.82 1.82 0 0 1 .026 2.567L12.529 8.09a.19.19 0 0 0-.043.191c.245.71.305 1.71.141 2.465-.004.021.022.035.037.02l2.26-2.308a3.81 3.81 0 0 0-.027-5.333 3.793 3.793 0 0 0-5.387.028L7.194 5.516z"></path>
        <path d="m11.412 11.645.004-.002c.461-.843.552-1.81.336-2.754l-.001.001h-.002a3.8 3.8 0 0 0-1.533-2.188.21.21 0 0 0-.233.01c-.387.314-.767.716-1.017 1.228a.17.17 0 0 0 .068.223c.29.168.552.415.728.743.137.231.272.67.185 1.143-.082.626-.714 1.2-1.217 1.717-.382.392-1.354 1.383-1.743 1.78a1.82 1.82 0 0 1-2.568.027 1.82 1.82 0 0 1-.026-2.568L5.458 9.91a.19.19 0 0 0 .044-.188C5.265 8.996 5.2 8.02 5.35 7.264c.004-.02-.022-.034-.037-.019L3.086 9.518a3.85 3.85 0 0 0 .028 5.387 3.8 3.8 0 0 0 5.36-.054c.506-.567 2.676-2.576 2.938-3.206"></path>
      </g>
      <defs>
        <clipPath id="clip0_635_22750">
          <path fill="#fff" d="M2 2h14v14H2z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default AttachFilesIcon;
